import { Thunk, RootDispatch } from 'store/types';
import { getLocationFromInput } from 'modules/utils/LocationUtils';
import { KEY } from '../../types';
import * as types from './types';

export const SEARCH_PHARMACIES = `${KEY}.SEARCH_PHARMACIES`;
export const SEARCH_PHARMACIES_SUCCESS = `${KEY}.SEARCH_PHARMACIES_SUCCESS`;
export const SEARCH_PHARMACIES_FAIL = `${KEY}.SEARCH_PHARMACIES_FAIL`;

export const searchPharmacies = (payload: types.SearchPharmaciesPayload) => ({
  type: SEARCH_PHARMACIES,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'searchPharmacies',
      data: payload
    }
  }
});

export const UPDATE_PREFERRED_PHARMACY = `${KEY}.UPDATE_PREFERRED_PHARMACY`;
export const UPDATE_PREFERRED_PHARMACY_SUCCESS = `${KEY}.UPDATE_PREFERRED_PHARMACY_SUCCESS`;
export const UPDATE_PREFERRED_PHARMACY_FAIL = `${KEY}.UPDATE_PREFERRED_PHARMACY_FAIL`;

export const updatePreferredPharmacy = (payload: types.UpdatePharmacyPayload) => ({
  type: UPDATE_PREFERRED_PHARMACY,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'updatePreferredPharmacy',
      data: payload
    }
  }
});

export const GET_PREFERRED_PHARMACY = `${KEY}.GET_PREFERRED_PHARMACY`;
export const GET_PREFERRED_PHARMACY_SUCCESS = `${KEY}.GET_PREFERRED_PHARMACY_SUCCESS`;
export const GET_PREFERRED_PHARMACY_FAIL = `${KEY}.GET_PREFERRED_PHARMACY_FAIL`;

export const getPreferredPharmacy = () => ({
  type: GET_PREFERRED_PHARMACY,
  payload: {
    client: 'amwell',
    request: {
      resourceName: 'getPreferredPharmacy'
    }
  }
});

export const GET_ALL_PHARMACIES = `${KEY}.GET_ALL_PHARMACIES`;
export const GET_ALL_PHARMACIES_SUCCESS = `${KEY}.GET_ALL_PHARMACIES_SUCCESS`;
export const GET_ALL_PHARMACIES_FAIL = `${KEY}.GET_ALL_PHARMACIES_FAIL`;

export const getAllPharmacies = ({
  latitude,
  longitude,
  pharmacyType,
  radius = 50
}: types.GetAllPharmaciesPayload): Thunk => (dispatch: RootDispatch) => {
  if (!latitude || !longitude) {
    dispatch({
      type: GET_ALL_PHARMACIES_FAIL,
      payload: {
        data: []
      }
    });
    return;
  }

  dispatch({
    type: GET_ALL_PHARMACIES,
    payload: {
      client: 'amwell',
      request: {
        resourceName: 'getAllPharmacies',
        data: {
          latitude,
          longitude,
          pharmacyType,
          radius
        }
      }
    }
  });
};

export const GET_ALL_PHARMACIES_BY_INPUT = `${KEY}.GET_ALL_PHARMACIES_BY_INPUT`;
export const GET_ALL_PHARMACIES_BY_INPUT_FAIL = `${KEY}.GET_ALL_PHARMACIES_BY_INPUT_FAIL`;
export const GET_ALL_PHARMACIES_BY_INPUT_SUCCESS = `${KEY}.GET_ALL_PHARMACIES_BY_INPUT_SUCCESS`;

export const getAllPharmaciesByInput = (input: string): Thunk => async dispatch => {
  let latitude;
  let longitude;

  const location = await getLocationFromInput(input);

  if (location && location.coords) {
    ({ latitude, longitude } = location.coords); // need parens to destructure without let/const
    dispatch(getAllPharmacies({ latitude, longitude, pharmacyType: 'RETAIL' }));
  }
};
